import styled from "styled-components";

const GiroExportText = styled.p`
  color: #333333;
  font-size: 20px;
  margin-bottom: 20px;
`;

export { GiroExportText };
